import { ApiResponseError } from '@sparklayer-io/spark-dash-core/types/errors';
import z from '@sparklayer-io/spark-dash-core/zod';
import type { PlatformConnectRequest, PlatformFormValues, PlatformValidationError } from './types';

const storeId = z.string().min(1);

export const platformSchema = z.discriminatedUnion('platform', [
  z.object({
    platform: z.literal('shopify'),
    platform_store_id: storeId,
  }),
  z.object({
    platform: z.literal('bigcommerce'),
    platform_store_id: storeId,
  }),
  z.object({
    platform: z.literal('wix'),
    platform_store_id: storeId,
  }),
  z.object({
    platform: z.literal('woocommerce'),
    platform_store_id: storeId,
    woocommerce_api_key: z.string().optional(),
    woocommerce_api_secret: z.string().optional(),
    woocommerce_basic_user: z.string().optional(),
    woocommerce_basic_pass: z.string().optional(),
  }),
  z.object({
    platform: z.literal('magento'),
    platform_store_id: storeId,
    magento_consumer_key: z.string().optional(),
    magento_consumer_secret: z.string().optional(),
    magento_access_token: z.string().optional(),
    magento_access_token_secret: z.string().optional(),
  }),
  z.object({
    platform: z.literal('custom'),
    platform_store_id: z.string(),
  }),
  z.object({
    platform: z.literal(''),
    platform_store_id: z.string(),
  }),
]);

export function buildPlatformPayload(values: PlatformFormValues): PlatformConnectRequest {
  const base = { platform: values.platform, platform_store_id: values.platform_store_id };

  switch (values.platform) {
    case 'woocommerce':
      return {
        ...base,
        woocommerce_api_key: values.woocommerce_api_key,
        woocommerce_api_secret: values.woocommerce_api_secret,
        woocommerce_basic_user: values.woocommerce_basic_user,
        woocommerce_basic_pass: values.woocommerce_basic_pass,
      };
    case 'magento':
      return {
        ...base,
        magento_consumer_key: values.magento_consumer_key,
        magento_consumer_secret: values.magento_consumer_secret,
        magento_access_token: values.magento_access_token,
        magento_access_token_secret: values.magento_access_token_secret,
      };
    default:
      return base;
  }
}

const platformValidationErrorSchema = z.object({
  message: z.string().optional(),
  errors: z.record(z.string(), z.array(z.string())),
});

export function isPlatformValidationError(
  err: unknown,
): err is ApiResponseError<PlatformValidationError> {
  return ApiResponseError.isApiResponseError(err, platformValidationErrorSchema);
}
